const POSITION = {
  aboveBoth: 'ABOVE BOTH (Bullish stance)',
  between: 'BETWEEN 50-day median and 200-day SMA (Transitional zone)',
} as const;

const TREND = {
  up: 'Uptrend (50-day median > 200-day SMA)',
  neutral: 'Neutral (50-day median ≈ 200-day SMA)',
} as const;

export type BuyConviction = {
  action: string;
  description: string;
};

/**
 * Classifica a oportunidade de compra a partir da posição do preço em relação
 * às médias móveis (positionSummary) e da tendência entre elas (trendContext).
 */
export function trendCalculate(positionSummary?: string, trendContext?: string): BuyConviction {
  if (!positionSummary || !trendContext) return { action: '', description: '' };

  const isUp = trendContext === TREND.up;
  const isNeutral = trendContext === TREND.neutral;

  if (positionSummary === POSITION.aboveBoth) {
    if (isUp) return { action: '★★★★★★☆☆☆', description: 'Golden Cross - Alta forte' }; // COMPRA MODERADA
    if (isNeutral) return { action: '★★★☆☆☆☆☆☆', description: 'Neutra com médias móveis próximas.' }; // COMPRA LEVE
    return { action: '★★★★☆☆☆☆☆', description: 'Death Cross - Baixa. Preço acima das médias.' }; // COMPRA ESPECULATIVA
  }

  if (positionSummary === POSITION.between) {
    if (isUp) return { action: '★★★★★★★☆☆', description: 'Golden Cross - Zona de transição em tendência de alta.' }; // COMPRA BOA
    if (isNeutral) return { action: '★★★★★☆☆☆☆', description: 'Zona de transição com médias móveis neutras.' }; // COMPRA TÁTICA
    return { action: '★☆☆☆☆☆☆☆☆', description: 'Death Cross - Zona de transição em tendência de baixa.' }; // EVITAR
  }

  // BELOW BOTH (Bearish stance)
  if (isUp) return { action: '★★★★★★★★☆', description: 'Golden Cross - Alta. Preço abaixo das médias.' }; // COMPRA MUITO BOA
  if (isNeutral) return { action: '★★☆☆☆☆☆☆☆', description: 'Neutra com médias móveis próximas e preço abaixo.' }; // COMPRA POUCO
  return { action: '★★★★★★★★★', description: 'Death Cross - Baixa forte.' }; // VENDA A CASA E COMPRE TUDO
}
